import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageObserveObservationService {
  isCollapsed = true;

  constructor(private service: PHBHPApiService) { }

  getDepartmentList() {
    return this.service.getApi('Departments/GetDepartments', true);
  }
  // getDepartmentById(id) {
  //   return this.service.getApi('Departments/GetDepartmentById/'+id, true);
  // }
  getWardsbyInstitutionId(id) {
    return this.service.getApi('ManageInstitution/GetInstituionWards/'+ id, true);
  }

  createObserveSession(session) {
    return this.service.postApi('Observation/CreateObservationSession', session, true);
  }

  createObservationSession(data, quotaId) {
    return this.service.postApi(`Observation/CreateObservationWithSession/${quotaId}`, data,true);
  }
  getUserSession(userId, institutionId, roleId) {
    return this.service.getApi(`ObserveObservation/GetUserSession/${userId}/${institutionId}/${roleId}`,true);
  }
  createObservation(data, quotaId) {
    return this.service.postApi(`Observation/CreateObservation/${quotaId}`, data,true);
  }

  updateObservation(data, id){
    return this.service.putApi(`Observation/UpdateObservation/${id}`, data, true);
  }
  updateSession(data, id){
    return this.service.putApi(`ObservationSession/UpdateSession/${id}`, data, true);
  }
  deleteObservation(id, userId) {
    return this.service.deleteApi(`Observation/DeleteObservation/${id}/${userId}`, true);
  }
  getUserSessionDetail(userId, institutionId, sessionId, countryId, lang){
    return this.service.getApi(`ObserveObservation/GetUserSessionDetail/${userId}/${institutionId}/${sessionId}/${countryId}/${lang}`, true);
  }
  getConfigDetails(id){
    return this.service.getApi('ObserveObservation/GetGeneralConfigurationByInstitutionId/' + id, true);
  }
  getQuotaDetailForCreateSession(institutionId, wardId, departmentId){
    return this.service.getApi(`Quota/GetQuotaDetailAndUpdateStatus/${institutionId}/${wardId}/${departmentId}`, true);
  }
  GetWardsAndDepartments(id){
    return this.service.getApi('SOPEvaluation/GetWardsAndDepartments/'+ id, true);
  }
  updateObservationsOfMappedWards(data) {
    return this.service.putApi('Observation/MigrationUpdateObservations',data , true);
  }
  checkPendingSessions(userId: number) {
    return this.service.getApi('ObservationSession/CheckPendingSessions/'+ userId, true);
  }
  updateObservationComments(data, userId){
    return this.service.putApi(`ObservationSession/UpdateComments/${userId}`, data, true);
  }
  getComplianceInstitutionData(institutionId) {
    return this.service.getApi(`Institutions/GetComplianceInstitutionData/${institutionId}`, true);
  }
  getObservationQuotaCount(quotaId) {
    return this.service.getApi(`ObservationSession/GetObservationQuotaCount/${quotaId}`, true);
  }
}
